import React from 'react';
import { ButtonBase, Collapse, Divider, Stack } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useAppSelector } from '../../../../hooks';
import { getConfigState } from '../../../../store/ConfigSlice';

interface AddHomeworkButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const AddHomeworkButton: React.FC<AddHomeworkButtonProps> = ({
  onClick,
  disabled = false,
}) => {
  // Store
  const { tutorHomeworkMode } = useAppSelector(getConfigState);

  return (
    <Collapse in={tutorHomeworkMode}>
      <Stack alignItems="center">
        <Divider
          orientation="vertical"
          sx={{ border: '1px dashed #CBD5E1', height: '7px', marginTop: '5px' }}
        />
        <ButtonBase
          disabled={disabled}
          sx={{ color: 'info.main', left: '48px', margin: '2px' }}
          onClick={onClick}
        >
          <AddCircleIcon fontSize="small" sx={{ mr: '5px' }} /> Add Homework
        </ButtonBase>
        <Divider
          orientation="vertical"
          sx={{ border: '1px dashed #CBD5E1', height: '7px' }}
        />
      </Stack>
    </Collapse>
  );
};

export default AddHomeworkButton;
